{
  "GenericFooter_ServerErrorTitle": "Validatiefouten",
  "GenericFooter_ValidationWarning": "Zorg ervoor dat alle velden correct zijn ingevuld",
  "GenericFooter_ButtonHelpLabel": "Hulp?",
  "GenericFooter_ButtonSubmitLabel": "Sla",
  "GenericFooter_ButtonCancelLabel": "Annuleren",
  "NAME": "GenericFooter"
}